import React, {useState, useContext, useEffect} from 'react';
import {Modal, Paper, Box, IconButton, Alert} from '@mui/material';
import {Autoform} from './autoform';
import {useForm} from 'react-hook-form';
import CloseIcon from '@mui/icons-material/Close';
import api from '../../hooks/useApi';
import DataContext from '../../hooks/FormsContext';
import jsonToFormData from '../../hooks/jsonToFormData';

const FetchForm = async (formName) => {
    try {
        const response = await api.get(`/api/CreateObjForms/${formName}/`);
        return response.data.form;
    } catch (error) {
        //console.error('Error fetching form:', error);
        return null;
    }
}

export default function ModalForm({formName, show, setShowModal, initialValues, onSuccess}) {
    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 500,
        p: 4,
    };

    // Устанавливаем начальные значения формы через defaultValues
    const formHook = useForm({
        defaultValues: initialValues // Начальные значения формы
    });

    const [formError, setFormError] = useState(null);

    const handleSubmitForm = async (data) => {
        try {
            const formData = jsonToFormData(data);
            const response = await api.post(`/api/${formName}/`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            if (response.status === 200 || response.status === 201) {
                // Уведомляем родителя об успешном создании
                if (typeof onSuccess === 'function') {
                    try {
                        await onSuccess(response);
                    } catch (e) { /* no-op */
                    }
                }
                // Закрываем модальное окно (если управляется снаружи)
                if (typeof setShowModal === 'function') setShowModal(false);
            } else {
                //console.error('Unexpected response status:', response.status);
            }
        } catch (error) {
            const res = error.response;
            const errorShow = res?.data?.message || res?.data?.detail || res?.data || 'Сталася помилка'
            setFormError(errorShow);
        }
    };

    const handleClose = () => {
        setShowModal(false);
    };

    return (
        <Modal open={show} onClose={handleClose}>
            <Box style={style}>
                <Paper sx={{p: '20px', maxHeight: '80vh', overflowY: 'auto'}}>
                    <Box style={{position: 'relative'}}>
                        <IconButton
                            style={{position: 'absolute', right: 5, border: "1px solid lightgrey"}}
                            onClick={handleClose}
                        >
                            <CloseIcon/>
                        </IconButton>
                        <h2>Забронювати</h2>
                        <AutoFormWrapper
                            formName={formName}
                            formHook={formHook}
                            handleSubmitForm={handleSubmitForm}
                        />
                        {formError && (
                            <Alert severity='error'>
                                Сталася помилка! {JSON.stringify(formError)}
                            </Alert>
                        )}
                    </Box>
                </Paper>
            </Box>
        </Modal>
    );
}

function AutoFormWrapper({formName, formHook, handleSubmitForm}) {
    const [form, setForm] = useState(null);
    const formContext = useContext(DataContext);
    const formFromContext = formContext ? formContext[formName] : null;

    useEffect(() => {
        if (formFromContext) {
            setForm(formFromContext);
        } else {
            const fetchFormData = async () => {
                const formData = await FetchForm(formName);
                setForm(formData);
            };
            fetchFormData();
        }
    }, [formName]);

    if (!form) {
        return <p>Завантаження форми...</p>;
    }

    return (
        <Autoform
            fields={form}
            formHook={formHook}
            onSubmit={handleSubmitForm}
            className={'modalFormWindow'}
            submitButton='Додати'
        />
    );
}
